import React from 'react';
import PropTypes from 'prop-types';
import AppModal from '../../shared/components/app-modal/AppModal';

function ArmedForcesAdvisoryModal({ show, onClose }) {
  if (!show) return null;

  return (
    <AppModal
      modalTitle="PFB the advisory:"
      showCloseButton
      onModalClose={onClose}
      className="armed-forces-advisory-modal"
    >
      <div className="armed-forces-advisory-content">
        <p>
          To avail Armed Forces Fares, it is mandatory for the travelling
          passengers to possess a valid and active Armed Forces ID card and/or
          Family Dependent Card in their name.
        </p>
        <p>
          The original ID card must be presented <strong>voluntarily</strong> at
          the check-in counter/<strong>boarding gate</strong> on the day of
          travel. Failure to present a valid ID may result in denial of boarding
          or payment of the applicable fare difference.
        </p>
      </div>
    </AppModal>
  );
}

ArmedForcesAdvisoryModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ArmedForcesAdvisoryModal;
